/**
 *
 * @module guidGeneratorResponse
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyObject,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class GuidGeneratorResponse
 *
 */
export default class GuidGeneratorResponse {

    /**
     *
     * @param {Object} options
     * @param {Number} [options.statusCode=0]
     * @param {String} [options.statusMessage='']
     * @param {String} options.token
     * @param {String} [options.region='']
     * @param {String} [options.sourceIP='']
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'GuidGeneratorResponse(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get token() {
                return `${this.ctor} options.token should be a String with length`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { statusCode, statusMessage, token, region, sourceIP } = options;

        nonEmptyString(token, errorMessage.token, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.statusCode = Check.number(statusCode) ? statusCode : 0;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.statusMessage = Check.string(statusMessage) ? statusMessage : '';

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.token = token;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.region = Check.string(region) ? region : '';

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.sourceIP = Check.string(sourceIP) ? sourceIP : '';

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/guidGeneratorResponse.js